import { reactive, ref } from "vue";
import { queryToDoList } from "@/api/myToDoList";

export default function useMyToDoListTable() {
  // 搜索条件ref
  const searchRef = ref(null);

  // 搜索条件
  const searchData = reactive({
    processName: "",
  });

  // 表格loading
  const tableLoading = ref(false);

  // 表格数据
  const tableData = ref([]);

  // 表格列配置
  const columns = ref([
    {
      label: "任务id",
      prop: "instanceId",
    },
    {
      label: "流程名称",
      prop: "processName",
    },
    {
      label: "发起时间",
      prop: "createTime",
    },
    {
      label: "结束时间",
      prop: "endTime",
    },
    {
      label: "发起人",
      prop: "creater",
    },
  ]);

  // 分页数据
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 获取页面数据
  const getList = () => {
    tableLoading.value = true;
    queryToDoList({
      pageNum: pages.page,
      pageSize: pages.limit,
      ...searchData,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    getList();
  };
  return {
    searchRef,
    searchData,
    tableLoading,
    tableData,
    columns,
    pages,
    getList,
    handleReset,
  };
}
